
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectsEditFormButton: {
    id: "ProjectsEditFormButton.button",
    defaultMessage: "Save project",
  }, 
});

export default MESSAGES;